function buildMapstuff() {
  $('.interactive-map g').click(function () {
    var id = $(this).attr('id');
    $('.map-overlays__overlay.active').removeClass('active');
    $('.overlay__' + id).addClass('active');
    $('body').append('<div class="map-backdrop"></div>')
  });

  $('.sustainability-organization #boxes g').click(function () {
    console.log('clicking');
    var id = $(this).attr('id');
    console.log(id);
    $('.map-overlays__overlay.active').removeClass('active');
    $('.overlay__' + id).addClass('active');
    console.log('.overlay__' + id);
    $('body').append('<div class="map-backdrop"></div>')
  });

  $(document).on('click', '.map-backdrop, .overlay__close', function () {
    // console.log('click');
    $('.map-backdrop').remove();
    $('.map-overlays__overlay.active').removeClass('active');
  });

  $('.scroll-graphic-wrapper').on('scroll', function(){
    $('.scroll-checker').addClass('hide');
  });

  $('.scroll-checker').click(function(){
    $(this).addClass('hide');
  });
}

$(document).keyup(function(e) {
  if (e.keyCode === 27) {
    $('.map-backdrop').remove();
    $('.map-overlays__overlay.active').removeClass('active');
  }
});

$(document).ready(function () {
  buildMapstuff();
});

$(window).resize(function () {
  buildMapstuff();
});